export { default } from "ember-moment/helpers/moment-calendar";
